import {Button, CloseButton, Modal, ModalBody, ModalFooter, ModalTitle, Spinner,} from "react-bootstrap";
import ModalHeader from "react-bootstrap/ModalHeader";
import React, {useMemo, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {TrucksList} from "./TrucksList";
import {faCancel, faPlus, faTruck} from "@fortawesome/free-solid-svg-icons";
import {DIALOG_OPTIONS} from "../../types/DialogOptionsType";
import {EMPTY_TRUCK, RRTruckType} from "../../types/RRTruckType";
import {TruckDetails} from "./TruckDetails";
import {useCollectionData} from "react-firebase-hooks/firestore";
import {collection} from "firebase/firestore";
import {trucksFBConverter} from "./TrucksFBConverter";
import {appFirestore} from "../../../index";

export function TrucksDialog({zIndex, show, onClose, onSelect}: DIALOG_OPTIONS) {
    const [editTruck, setEditTruck] = useState<RRTruckType | null>(null);

    const trucksCollection = useMemo(
        () => collection(appFirestore, "trucks").withConverter(trucksFBConverter),
        []
    );
    const [trucks, loading, error] = useCollectionData(trucksCollection);

    function addNewTruck() {
        setEditTruck({...EMPTY_TRUCK});
    }

    return (
        <>
            <Modal show={show} size={"lg"} style={{zIndex: (zIndex + 1)}}>
                <ModalHeader>
                    <ModalTitle>
                        <FontAwesomeIcon icon={faTruck}/> Списък на превозните средства
                    </ModalTitle>
                    <CloseButton onClick={() => onClose(null)}/>
                </ModalHeader>

                <ModalBody>
                    {
                        loading && <div className={"text-center"}>
                            <Spinner animation={"border"}/>
                        </div>
                    }

                    {
                        error && <div className={"text-danger text-center"}>
                            Грешка при зареждане на превозните средства: {error.message}
                        </div>
                    }

                    {
                        editTruck ?
                            <TruckDetails
                                truck={editTruck}
                                onDone={() => {
                                    setEditTruck(null);
                                }}
                            /> :
                            <>
                                {
                                !loading && !error &&
                                <TrucksList
                                    trucks={trucks ?? []}
                                    onSelect={onSelect}
                                    onEdit={(truck: RRTruckType) => {
                                        setEditTruck(truck);
                                    }}
                                />
                            }
                            </>
                    }
                </ModalBody>

                {
                    !editTruck &&
                    <ModalFooter>
                        <Button onClick={addNewTruck}>
                            <FontAwesomeIcon icon={faPlus}/> Добави нов
                        </Button>
                        <Button variant={"outline-secondary"} onClick={() => {
                            onClose(null)
                        }}>
                            <FontAwesomeIcon icon={faCancel}/> Затвори
                        </Button>
                    </ModalFooter>
                }
            </Modal>
        </>
    )
}
